import { Component, OnDestroy, OnInit } from '@angular/core';
import { interval, PartialObserver, Subject, Subscription } from 'rxjs';
import { AlertaService } from 'src/app/api-service/alerta.service';
import { Alerta } from 'src/app/models/alerta';
import { AlertaModel } from 'src/app/models/alerta.model';
import { Conta } from 'src/app/models/conta';
import { EnumAlertaNivel } from 'src/app/models/enums/enumAlertaNivel';
import { EnumAlertaStatus } from 'src/app/models/enums/enumAlertaStatus';
import { EnumAlertaTipo } from 'src/app/models/enums/enumAlertaTipo';
import { Gestor } from 'src/app/models/gestor';
import { AuthTokenService } from 'src/app/services/auth-token.service';
import { AuthService } from 'src/app/services/auth.service';
import { SessionsService } from 'src/app/services/sessions.service';
import { ShowModalService } from 'src/app/services/show-modal.service';
import { Login } from 'src/app/share/login';
import { Paginacao } from 'src/app/share/Paginacao';

import { Util } from 'src/app/share/Util';
import { ModalAlertaComponent } from './modal-alerta/modal-alerta.component';

@Component({
  selector: 'app-alerta',
  templateUrl: './alerta.component.html',
  styleUrls: ['./alerta.component.scss'],
})
export class AlertaComponent implements OnInit, OnDestroy {
  login: Login;
  alertas: AlertaModel[];
  alerta: Alerta;
  listTabs: any[] = [];
  subscription: Subscription;
  EnumAlertaTipo = (index: number) => EnumAlertaTipo[index];
  EnumAlertaNivel = (index: number) => EnumAlertaNivel[index];
  permissaoEdicao: any;
  subs: Array<Subscription> = [];

  // Tipo do alerta (radiobox)
  tipo: string;

  // Paginação
  paginacao: Paginacao<AlertaModel>;
  perPage: number = 10;
  p: number;
  total: number;
  atual: number;
  totalPaginas: number[];
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = true;
  public labels: any = {
    previousLabel: 'Anterior',
    nextLabel: 'Próximo',
    screenReaderPaginationLabel: 'Paginação',
    screenReaderPageLabel: 'página',
    screenReaderCurrentLabel: `Você está na página`,
  };

  constructor(
    private sessions: SessionsService,
    private authService: AuthService,
    private alertaService: AlertaService,
    private authToken: AuthTokenService,
    public showModalService: ShowModalService
  ) {
    this.permissaoEdicao = false;
    this.paginacao = new Paginacao('', 1, this.perPage, false);
    this.tipo = EnumAlertaTipo.Usuário.toString();
    this.login = this.sessions.getLogin();

    let tiposUsuarios = Object.getOwnPropertyNames(this.login).filter((x) => x.endsWith('Id'));
    tiposUsuarios.forEach((tu) => {
      if (tu == 'usuarioId') this.listTabs.push({ nome: 'Pessoais', tipoAlerta: 0 });
      if (tu == 'entidadePublicaId') this.listTabs.push({ nome: 'Entidade Pública', tipoAlerta: 3 });
      if (tu == 'consorioId') this.listTabs.push({ nome: 'Consórcio', tipoAlerta: 6 });
      if (tu == 'contaId') this.listTabs.push({ nome: 'Conta', tipoAlerta: 1 });
      if (tu == 'gestorId') this.listTabs.push({ nome: 'Administradores', tipoAlerta: 2 });
      if (tu == 'lojaId') this.listTabs.push({ nome: 'Loja', tipoAlerta: 7 });
      if (tu == 'bilhetadoraId') this.listTabs.push({ nome: 'Bilhetadora', tipoAlerta: 4 });
      if (tu == 'operadoraId') this.listTabs.push({ nome: 'Empresa de Transporte', tipoAlerta: 5 });
    });

    this.alerta = new Alerta();
    this.subs.push(
      this.authService.fechaAlert.subscribe((alert) => {
        this.alerta.mensagem = alert.mensagem;
        this.alerta.nivel = alert.classe;
        this.alerta.mostraAlerta = true;
        setTimeout(() => {
          this.alerta.mostraAlerta = false;
        }, 4000);
      })
    );

    this.subscription = this.alertaService.mensagem$.subscribe((message) => {
      this.tipo = null;
      this.tipo = message;
      this.getPage(1);
    });
  }
  ngOnDestroy(): void {
    this.subs.forEach((x) => x.unsubscribe());
  }

  ngOnInit() {
    this.getPage(1);
  }

  listagem() {
    this.authService.showLoadingEmitter.emit(true);
    const params = this.paginacao.retornaParametros().set('Tipo', this.tipo);

    this.alertaService
      .getAlertas(params)
      .then((dados) => {
        this.alertas = dados.listaItens.map((x) => new AlertaModel(x));
        this.atual = dados.numeroPagina;
        this.total = dados.totalItens;
        this.totalPaginas = Util.iniciaTotalPaginas(dados.totalPaginas);
      })
      .finally(() => this.authService.showLoadingEmitter.emit(false));
  }

  marcar(alerta: AlertaModel) {
    alerta.status =
      alerta.status == EnumAlertaStatus['Não Lido'] ? EnumAlertaStatus.Lido : EnumAlertaStatus['Não Lido'];

    this.alertaService
      .putAlerta(alerta)
      .then((success) => {
        this.listagem();
        this.alertaService.sendUpdateNotifications(true);
      })
      .catch((err) => {
        this.authService.fechaAlert.emit({
          mensagem: 'Erro ao marcar mensagem de alerta como não lido. Tente mais tarde!',
          classe: 'danger',
        });
        this.listagem();
      });
  }

  // Paginação
  getPage(page: number) {
    this.p = page;
    this.paginacao.numeroPagina = page;
    this.listagem();
  }

  setItemsPerPage(event: any) {
    this.perPage = event.target.value;
    this.paginacao.tamanho = this.perPage;
    this.getPage(1);
  }

  setaTipoAlerta(tipoAlerta: any) {
    this.tipo = tipoAlerta;
    this.listagem();
  }

  openModal(acao: string, alerta: AlertaModel): void {
    let initialState = {};

    initialState = {
      type: 'edit',
      title: 'Visualizar',
      permissao: this.permissaoEdicao,
      id: alerta.id,
    };

    this.showModalService.show(ModalAlertaComponent, 'modal-xl', initialState, () => {
      if (alerta.status == EnumAlertaStatus['Não Lido']) this.marcar(alerta);
    });
  }

  verificaStatus(status: EnumAlertaStatus): boolean {
    if (status == EnumAlertaStatus.Lido) return false;
    else return true;
  }

  setaCor(nivel: EnumAlertaNivel): string {
    if (nivel == EnumAlertaNivel.Alerta) return '#006400';
    else if (nivel == EnumAlertaNivel.Crítico) return '#ff0000';
    else if (nivel == EnumAlertaNivel.Grave) return '#800080';
    else return '#00008b';
  }
}
